<template>
  <div class="comp-quote fit-height">
    <div v-if="QUOTE">
      <div class="quote-head details-head">
        <div class="inn">
          <div class="info">
            <ul class="meta">
              <li>Quote #{{ QUOTE.quote_number }}</li>
              <li>
                <div class="dropdown">
                  <a href="javascript:;" class="status dropdown-toggle" :class="status" data-toggle="dropdown" @click="showStatusDropdown = !showStatusDropdown">{{ status | statusToUCWords}}</a>
                  <div class="dropdown-menu" :class="{show: showStatusDropdown == true}">
                    <a class="dropdown-item" href="javascript:;" @click="updateStatus(jstatus)" v-for="jstatus in quoteStatuses" :key="jstatus" :value="jstatus">
                      {{ jstatus | statusToUCWords }}
                    </a>
                  </div>
                </div>
              </li>
            </ul>
            <div class="title">
              <template v-if="editQuoteName">
                <form method="post" action="" @submit.prevent="updateName">
                  <input type="text" class="form-control" v-model="newQuoteName" ref="inputTitle" @blur="updateName">
                </form>
              </template>
              <template v-else>
                <span>{{ QUOTE.name }}</span>
                <a href="javascript:;" class="edit icon-pencil"
                   @click="editQuoteName = true"></a>
              </template>
            </div>
          </div>
          <div class="btns">
            <button type="button" class="btn btn-outline-gray" @click="confDuplicate">Duplicate</button>&nbsp;
            <button type="button" class="btn btn-outline-gray" @click="showInvoiceForm = true">Create Invoice</button>&nbsp;
            <button type="button" class="btn btn-outline-black" @click="downloadPDF">Download</button>
          </div>
        </div>
      </div>
      <div class="auto-height">
        <ul class="quote-details no-bottom">
          <li>
            <div class="form-row">
              <label class="lb">CREATED</label>
              <div class="inputs">
                <date-picker format="DD/MM/YYYY" value-type="YYYY-MM-DD" v-model="postData.created_at" name="created_at" :editable="false"
                             input-class="form-control" style="display: block;width: 100%;"></date-picker>
              </div>
            </div>
            <div class="form-row">
              <label class="lb">CLIENT PO</label>
              <div class="inputs">
                <input type="text" class="form-control"  v-model="postData.client_po">
              </div>
            </div>
            <div class="form-row">
              <label class="lb">
                RELATED JOB
                <template v-if="postData.job_id">
                  <br/>
                  <router-link target="_blank" :to="{ name: 'job', params: { jobId: postData.job_id } }">Go to job</router-link>
                </template>
              </label>
              <div class="inputs">
                <v-select v-model="postData.job_id" :options="allJobs" class="form-control" :reduce="item => item.id"
                          label="name" :searchable="true" :placeholder="'- Select job'"></v-select>
              </div>
            </div>
          </li>
          <li>
            <div class="form-row">
              <label class="lb">DESCRIPTION</label>
              <div class="inputs">
                <textarea-autosize :min-height="97" :max-height="100" class="form-control" v-model="postData.description"></textarea-autosize>
              </div>
            </div>
            <div class="form-row">
              <label class="lb">MANAGER</label>
              <div class="inputs">
                <v-select v-model="postData.manager_id" :options="allStaffs" class="form-control" :reduce="item => item.id"
                          label="full_name" :searchable="true" :placeholder="'- Select manager'"></v-select>
              </div>
            </div>
          </li>
          <li>
            <div class="form-row">
              <label class="lb">CLIENT</label>
              <div class="inputs">
                <v-select v-model="postData.client_id" :options="allClients" class="form-control" :reduce="item => item.id"
                          label="name" :searchable="true" :clearable="false"></v-select>
              </div>
            </div>
            <div class="form-row">
              <label class="lb">PRICE TIER</label>
              <div class="inputs">
                <div type="text" class="form-control">{{ currentPriceTier }}</div>
              </div>
            </div>
          </li>
        </ul>
        <ul class="quote-details">
          <li class="two-col">
            <div class="form-row">
              <label class="lb">NOTE</label>
              <div class="inputs">
                <textarea-autosize :min-height="97" :max-height="100" class="form-control" v-model="postData.note"></textarea-autosize>
              </div>
            </div>
          </li>
          <li>
            <div class="text-right">
              <beat-loader v-if="state == 'saving'"></beat-loader>
              <template v-else>
                <button type="button" class="btn btn btn-primary w180" @click="saveQuote(null)">Save</button>
              </template>
            </div>
          </li>
        </ul>

        <div class="quote-items">
          <div class="table-responsive">
            <table class="table table-sm">
              <thead>
              <tr>
                <th width="60"><a href="javascript:;" data-sort-field="sequence" @click="doSort($event)" class="sort asc">#</a></th>
                <th width="120"><a href="javascript:;" data-sort-field="category_name" @click="doSort($event)" class="sort">CATEGORY</a></th>
                <th width="140"><a href="javascript:;" data-sort-field="cost_description" @click="doSort($event)" class="sort">ITEM</a></th>
                <th><a href="javascript:;" data-sort-field="details" @click="doSort($event)" class="sort">DETAILS</a></th>
                <th width="100"><a href="javascript:;" data-sort-field="quantity" @click="doSort($event)" class="sort">QTY/HOURS</a></th>
                <th width="90"><a href="javascript:;" data-sort-field="quote_makeup" @click="doSort($event)" class="sort">MARKUP</a></th>
                <th width="90"><a href="javascript:;" data-sort-field="cost_rate" @click="doSort($event)" class="sort">COST RATE</a></th>
                <th width="100"><a href="javascript:;" data-sort-field="cost_amount" @click="doSort($event)" class="sort">COST</a></th>
                <th width="100"><a href="javascript:;" data-sort-field="quote_rate" @click="doSort($event)" class="sort">QUOTE RATE</a></th>
                <th width="100"><a href="javascript:;" data-sort-field="quote_amount" @click="doSort($event)" class="sort">QUOTED</a></th>
                <th width="50"></th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(item, index) in quoteItems">
                <quote-item-row :item="item" :client="currentClient" :key="index" :idx="index" @item-saved="onItemSaved" @item-deleted="onItemDeleted"></quote-item-row>
              </template>
              <quote-item-row v-if="isAdding" :max_sequence="maxSequence" :client="currentClient" idx="-1" @item-saved="onItemSaved" @item-cancelled="onItemCancelled"></quote-item-row>
              </tbody>
            </table>
          </div>
          <div>
            <div class="custom-control custom-checkbox mb-2">
              <input type="checkbox" class="custom-control-input" id="hide_hours" v-model="postData.hide_hours" @change="saveQuote(null)">
              <label class="custom-control-label" for="hide_hours">Hide hours in quote</label>
            </div>
          </div>
          <div class="text-center">
            <button v-if="!isAdding" type="button" class="btn btn-outline-black w180" @click="isAdding = true">Add Item</button>
          </div>
        </div>

        <div class="quote-summary">
          <div class="table-responsive">
            <table class="table">
              <tbody>
              <tr>
                <td>TOTAL</td>
                <td width="270">QTY/HOURS: {{ totalQuantity }}</td>
                <td width="190">${{ totalCostAmount | numberFormat }}</td>
                <td width="170">${{ totalQuoteAmountIncGST | numberFormat }} INC. GST</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td colspan="2"></td>
                <td>GROSS PROFIT</td>
                <td>${{ grossProfit | numberFormat }}</td>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
    <modal-add-invoice-from-quote v-model="showInvoiceForm" :quote="QUOTE" @added="onInvoiceAdded"></modal-add-invoice-from-quote>
  </div>
</template>

<script>

  import {mapGetters, mapState} from 'vuex'
  import {forEach, orderBy} from "lodash";
  import jquery from "jquery";
  import ServiceQuote from '@/services/quote'
  import ModalDuplicate from './ModalDuplicate';
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import QuoteItemRow from './QuoteItemRow';
  import DatePicker from 'vue2-datepicker';
  import ModalAddInvoiceFromQuote from './ModalAddInvoiceFromQuote'

  export default {
    components: {
      BeatLoader,
      QuoteItemRow,
      DatePicker,
      ModalAddInvoiceFromQuote
    },
    data () {
      return {
        state: '',
        status: 'pending',
        updated_dtm: 0,
        editQuoteName: false,
        newQuoteName: '',
        showStatusDropdown: false,
        postData: {
          created_at: '',
          job_id: '',
          description: '',
          note: '',
          manager_id: '',
          client_id: '',
          price_tier: 'tier1',
          client_po: '',
          hide_hours: false
        },
        quoteItems: [],
        sort: 'sequence',
        order: 'asc',
        isAdding: false,
        totalQuantity: 0,
        totalMarkup: 0,
        totalCostAmount: 0,
        grossProfit: 0,
        totalQuoteAmount: 0,
        totalQuoteAmountIncGST: 0,
        currentClient: null,
        currentPriceTier: 'Tier 1',
        showInvoiceForm: false,
        maxSequence: 0
      }
    },
    props: ['quoteId'],
    watch: {
      quoteId (newVal) {
        if ( newVal && this.QUOTE && this.QUOTE.id != newVal )
          this.init();
      },
      editQuoteName (newVal) {
        let self = this;
        if ( newVal ) {
          self.newQuoteName = self.QUOTE.name;
          setTimeout(() => {
            self.$refs.inputTitle.focus();
          }, 200);
        }
      },
      'postData.job_id': function (newVal) {
        if(newVal) {
          let self = this;
          let job = window.getObjectByKeyValue(this.allJobs, 'id', newVal);
          if(job) {
            self.postData.client_id = job.client_id;
          }
        }
      },
      'postData.client_id': function (newVal) {
        if(newVal) {
          let self = this;
          let client = window.getObjectByKeyValue(this.allClients, 'id', newVal);
          self.currentClient = client?client:null;
          let tier = client ? window.getObjectByKeyValue(this.priceTiers, 'code', client.price_tier) : null;
          if (tier) {
            self.currentPriceTier = tier.name;
            self.postData.price_tier = tier.code;
          } else {
            self.currentPriceTier = 'Tier 1';
            self.postData.price_tier = 'tier1';
          }
        }
      }
    },
    computed: {
      ...mapGetters(['QUOTE']),
      ...mapState({
        tinyApiKey: state => state.option.tinyApiKey,
        tinyOpts: state => state.option.tinyOpts,
        allJobs: state => state.option.jobs,
        allStaffs: state => state.option.users,
        allClients: state => state.option.clients,
        quoteStatuses: state => state.option.quoteStatuses,
        priceTiers: state => state.option.priceTierOpts
      })
    },
    mounted () {
      this.init();
    },
    methods: {
      init () {
        let self = this;
        self.showModalEdit = false;
        self.$store.dispatch('GET_QUOTE', self.quoteId)
          .then(() => {
            self.populateData();
          });
      },
      _generateExtraAttributes (quoteItem) {
        let amount = 0;
        quoteItem.sequence = parseInt(quoteItem.sequence);
        quoteItem.category_name = quoteItem.cost && quoteItem.cost.category ? quoteItem.cost.category.name : '';
        quoteItem.cost_description = quoteItem.cost ? quoteItem.cost.description : '';
        quoteItem.quote_makeup = null;
        if (quoteItem.quote_rate && quoteItem.cost_rate && quoteItem.quantity) {
          amount = (quoteItem.quote_rate - quoteItem.cost_rate)*quoteItem.quantity;
          if (amount)
            quoteItem.quote_makeup = amount;
        }

        amount = 0;
        quoteItem.cost_amount = null;
        if (quoteItem.cost_rate && quoteItem.quantity) {
          amount = quoteItem.cost_rate*quoteItem.quantity;
          if (amount)
            quoteItem.cost_amount = amount;
        }

        amount = 0;
        quoteItem.quote_amount = null;
        if (quoteItem.quote_rate && quoteItem.quantity) {
          amount = quoteItem.quote_rate*quoteItem.quantity;
          if (amount)
            quoteItem.quote_amount = amount;
        }

        return quoteItem;
      },
      populateData () {
        let self = this;
        for(let f in self.postData){
          if(typeof self.QUOTE[f] != 'undefined')
            self.postData[f] = self.QUOTE[f];
        }
        self.status = self.QUOTE.status;
        self.quoteItems = forEach(self.QUOTE.items, (quoteItem) => {
          self._generateExtraAttributes(quoteItem);
        });
        self.quoteItems = orderBy(self.quoteItems, [self.sort], [self.order]);
        self.getTotals();
      },
      updateName () {
        let self = this;
        // save to DB
        setTimeout(() => {
          if(self.newQuoteName != self.QUOTE.name){
            self.QUOTE.name = self.newQuoteName;
            self.saveQuote({name: self.newQuoteName});
          }
          self.editQuoteName = false;
        }, 1000);
      },
      updateStatus (newStatus) {
        let self = this;
        if(newStatus && newStatus != self.status){
          self.status = newStatus;
          self.saveQuote({status: newStatus}, function(){
            self.$notify({
              type: 'success',
              text: 'A job has been created',
              duration: 5000
            });
          });
        }
        self.showStatusDropdown = false;
      },
      saveQuote (updateData, callback) {
        let self = this;
        if (self.state == 'saving') {
          return;
        }
        if (updateData == null) {
          updateData = {};
          Object.assign(updateData, self.postData);
        }

        self.state = 'saving';
        ServiceQuote.save(self.QUOTE.id, updateData, quote => {
          let now = new Date().getTime();
          if(now - self.updated_dtm > 5*1000){
            self.$notify({
              type: 'success',
              text: 'Quote updated'
            });
            self.updated_dtm = now;
          }
          if (typeof callback == "function")
            callback();
          self.state = '';
          let job = window.getObjectByKeyValue(this.allJobs, 'id', quote.job_id);
          if(!job && quote.job_id && quote.job)
            self.$store.dispatch('ADD_QUOTE_JOB_DATA', quote.job);
          self.$store.dispatch('UPDATE_QUOTE', quote).then(() => {
            self.populateData();
          });
        }, () => {
          self.state = '';
        });
      },
      confDuplicate () {
        let self = this;

        self.$modal.show(ModalDuplicate, {
          quote: self.QUOTE
        }, {
          clickToClose: false,
          width: 592
        });
      },
      getTotals(){
        let self = this;
        self.totalQuantity = 0;
        self.totalMarkup = 0;
        self.totalCostAmount = 0;
        self.grossProfit = 0;
        self.totalQuoteAmount = 0;
        if(self.quoteItems.length){
          for(let i = 0; i < self.quoteItems.length; i++){
            let item = self.quoteItems[i];
            self.totalQuantity += parseFloat(item.quantity);
            //self.totalMarkup += item.quantity*(item.quote_rate-item.cost_rate);
            self.totalMarkup += item.quote_makeup ? item.quote_makeup : 0;

            //self.totalCostAmount += item.cost_rate*item.quantity;
            self.totalCostAmount += item.cost_amount ? item.cost_amount : 0;

            //self.totalQuoteAmount += item.quote_rate*item.quantity;
            self.totalQuoteAmount += item.quote_amount ? item.quote_amount : 0;

            if (self.maxSequence < parseInt(item.sequence)) {
              self.maxSequence = parseInt(item.sequence);
            }
          }
          self.grossProfit = self.totalQuoteAmount - self.totalCostAmount;
          self.totalQuoteAmountIncGST = self.totalQuoteAmount * 1.1;
        }
      },
      onItemCancelled () {
        this.isAdding = false;
      },
      onItemDeleted (index) {
        let self = this;
        if (typeof self.quoteItems[index] != 'undefined') {
          let item = self.quoteItems[index];
          self.quoteItems.splice(index, 1);
          self.$notify({
            type: 'success',
            text: '<strong>' + item.details + '</strong> item is deleted'
          });
          self.quoteItems = orderBy(self.quoteItems, [self.sort], [self.order]);
          self.getTotals();
        }
      },
      onItemSaved ( item, index ) {
        let self = this;
        if(index != -1)
          self.quoteItems.splice( index, 1, self._generateExtraAttributes(item) );
        else
          self.quoteItems.push( self._generateExtraAttributes(item) );
        self.isAdding = false;
        self.quoteItems = orderBy(self.quoteItems, [self.sort], [self.order]);
        self.getTotals();
      },
      doSort (event) {
        let self = this, params = {}, header = event.target;
        // Go through all header and reset the sort class
        jquery('.sort').not(header).attr('class', 'sort');

        if (typeof header.dataset.sortField != 'undefined') {
          params['sort'] = header.dataset.sortField;
          if (header.className.indexOf('asc') == -1) {
            /* Not sort or in desc */
            params['order'] = 'asc';
            header.className = header.className.replace(' desc', '') + ' asc';
          } else if (header.className.indexOf('desc') == -1) {
            params['order'] = 'desc';
            header.className = header.className.replace(' asc', '') + ' desc';
          }
          self.sort = params['sort'];
          self.order = params['order'];

          self.quoteItems = orderBy(self.quoteItems, [self.sort], [self.order]);
        }
      },
      downloadPDF () {
        let self = this;
        if ( self.status == 'processing' ) {
          return;
        }
        self.state = 'processing';
        ServiceQuote.downloadPDF(self.QUOTE.id, {sort: self.sort, order: self.order}, resp => {
          self.state = '';
          window.downloadFromBlob(resp.data, 'quote_' + self.QUOTE.id + '.pdf');
        }, () => {
          self.state = '';
        });
      },
      cloneQuote: function(){
        let self = this;
        if ( self.state == 'processing' ) {
          return;
        }
        self.$dialog
          .confirm('Are you sure you want to clone this quote?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            self.state = 'processing';
            ServiceQuote.clone({ id: self.QUOTE.id }, quote => {
              self.state = '';
              dialog.close();
              self.$notify({
                type: 'success',
                text: 'This quote has been cloned. '
              });

              self.$dialog
                .confirm('Do you want to navigate to the new quote details page?', {
                  html: true,
                  loader: true,
                  okText: "Yes, I do",
                  cancelText: "Cancel",
                })
                .then(dialog => {
                  dialog.close();
                  self.$router.push({
                    name: 'quote',
                    params: {
                      quoteId: quote.id
                    }
                  });
                })
                .catch(() => {});
            });
          })
          .catch(() => {});
      },
      onInvoiceAdded: function( invoice ) {
        let self = this;
        self.$dialog
          .confirm('Do you want to navigate to the new invoice details page?', {
            html: true,
            loader: true,
            okText: "Yes, I do",
            cancelText: "Cancel",
          })
          .then(dialog => {
            dialog.close();
            self.$router.push({
              name: 'invoice',
              params: {
                invoiceId: invoice.id
              }
            });
          })
          .catch(() => {});
      }
    }
  }
</script>
